import styled from 'styled-components'

const Content = styled.div`
  align-items: center;
  display: flex;
  flex-grow: 1;
`

export default Content
